/**
 * Phone OTP verification — Prelude-backed routes for mobile + web JSON clients.
 *
 * @see app/api/phone/send-otp/route.ts
 * @see app/api/phone/verify-otp/route.ts
 */

import { z } from "zod";
import { pinned } from "./pin";

export interface PhoneSendOtpRequest {
  phoneNumber: string;
}

export interface PhoneSendOtpResponse {
  verificationId: string;
}

export interface PhoneVerifyOtpRequest {
  verificationId: string;
  otp: string;
  phoneNumber: string;
}

export interface PhoneVerifyOtpResponse {
  success: true;
}

export const PhoneSendOtpRequestSchema = pinned<PhoneSendOtpRequest>()(
  z.object({
    phoneNumber: z.string().min(8),
  }),
);

export const PhoneSendOtpResponseSchema = pinned<PhoneSendOtpResponse>()(
  z.object({
    verificationId: z.string().min(1),
  }),
);

export const PhoneVerifyOtpRequestSchema = pinned<PhoneVerifyOtpRequest>()(
  z.object({
    verificationId: z.string().min(1),
    otp: z.string().min(4).max(8),
    phoneNumber: z.string().min(8),
  }),
);

export const PhoneVerifyOtpResponseSchema = pinned<PhoneVerifyOtpResponse>()(
  z.object({
    success: z.literal(true),
  }),
);
